import { render, staticRenderFns } from "./SystemActivityType.vue?vue&type=template&id=3bda0319&"
import script from "./SystemActivityType.vue?vue&type=script&lang=js&"
export * from "./SystemActivityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports